import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reason'
})
export class ReasonPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return this.getReasonType(value);
  }

  getReasonType(status: string): String {
    if (status === 'employment_within_company') {
      return 'Employment Within Company';
    } else if (status === 'employment_outside_company') {
      return 'Employment Outside Company';
    } else if (status === 'further_education') {
      return 'Further Education';
    } else if (status === 'absconding') {
      return 'Absconding';
    } else if (status === 'disciplinary_reason') {
      return 'Disciplinary Reason';
    } else if (status === 'other_reason') {
      return 'Other Reason';
    }
    return '--'
  }

}
